import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import * as Yup from "yup";
import { Field, Formik } from "formik";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Input,
  Modal,
  ModalBody,
  ModalHeader
} from "reactstrap";
import { cloneDeep, find } from "lodash";
import moment from "moment";
import useAxios from "hooks/useAxios";
import useContextService from "hooks/useContextService";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import CoveredEntity from "components/CoveredEntity";
import Calendar from "assets/icon/calendar-icon.svg";
import Pharmacy from "components/Pharmacy";
import { default as ReactSelect } from "react-select";
import { Option, LimitedChipsContainer } from "components/Options";
import AddOrderModal from "../PurchaseOrderTable/components/Add";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";
import useThirdPartyAdmin from "hooks/UseThirdPartyAdmin";
import plus from "assets/icon/plus-icon.svg";
import { ModuleAccess } from "utils/moduleaccess";

let hasDatePopupOpen = false;
const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required("Third Party Administrator is required"),
});

let tpaerror = "";
let cperror = "";
let ceData = [];
let cpData = [];
let pharmacyData = [];
const SearchOrders = (props) => {
  const API = useAxios();

  const { data } = useThirdPartyAdmin();
  useEffect(() => {
    setAccessType(data);

  }, [data])
  const {
    states: { purchaseOrder },
    setStates,
    resetStates,
  } = useContextService();
  const { onSearch, onReset, selectedOption, setOptionSelected, selectedOpt, setOptSelected, accountype,
    setAccountype , refetch } = props;
  const [isSubmitting, setSubmitting] = useState(true);
  const [wholesalers, setwholesalers] = useState([]);
  const [ceDatalist, setCeDatalist] = useState([]);
  const [cpDatalist, setCpDatalist] = useState([]);
  const [poStatus, setPOStatus] = useState([]);
  const [selectedCP, setSelectedCP] = useState(null);
  const [chainPharmacyList, setChainPharmacyList] = useState();
  const [isTPA, setIsTPA] = useState(false);
  
// const { pharmacyids } =
//   searchTerms;

  const {
    thirdPartyAdmin,
    searchTerms,
    coveredEntity,
    wholesaler,
    orderStatus,
    pharmacy,
  } = purchaseOrder;
  const {
    thirdPartyAdminID,
    coveredEntityID,
    pharmacyID,
    startDate,
    invoicenumber,
    poNumber,
    wholesalerID,
    endDate,
    orderStatusID,
    ceIds,
    chainPharmacyID
  } = searchTerms;
  const { tenantID } = thirdPartyAdmin;


  const accountypevalues = isTPA == false ? [
    { id: 1, label: "340B" },
    { id: 2, label: "Non-340B" },
  ]
    : [
      { id: 1, label: "340B" }
    ]

  const handelAccountype = (e, setFieldValue) => {
    setAccountype(e.target.value)

  }

   const [state, updateState] = useState({
      AddOrderModal: false,
    });

    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

    const onToggleAddOrderModal = () => {
      setState({
        addOrderModal: !state.addOrderModal,
      });
    };

    const { addOrderModal } = state;

  const updateStates = (purchaseOrder) => {
    setStates("purchaseOrder", purchaseOrder);
  };

   const hasPermission = (code) => {
      return ModuleAccess("PO", code);
  
    }

  useEffect(() => {
    // resetForm();
    onReset();
    setOptionSelected({ optionSelected: "-1" });
    // purchaseOrder.searchTerms.ceIds = {};
    // purchaseOrder.searchTerms.chainPharmacyID = null;
    // purchaseOrder.searchTerms.poNumber = '' ;
    purchaseOrder.orderStatus = "";
    purchaseOrder.searchTerms.orderStatusID = "";
    resetStates("purchaseOrder");
    setCeDatalist([]);
    setCpDatalist([]);
    setwholesalers([]);
    pharmacyData = [];
    ceData = [];
    cpData = [];
    setOptSelected({ optSelected: "-1" });
    setSelectedCP(null);
    tpaerror = "" ;
    cperror = "" ;
    if (accountype == 2) { fetchChainPharmacies() }
  }, [accountype])

  useEffect(() => {
    purchaseOrder.thirdPartyAdmin = {};
    purchaseOrder.coveredEntity = null;
    purchaseOrder.pharmacy = null;
    resetStates("purchaseOrder");
  }, []);

  useEffect(() => {
    fetchPOStatus();
  }, []);
useEffect(() =>{
    onReset();
    resetStates("purchaseOrder");
    setOptionSelected({ optionSelected: "-1" });
    purchaseOrder.searchTerms.ceIds = {};
    purchaseOrder.searchTerms.chainPharmacyID = null;
    purchaseOrder.searchTerms.poNumber = '' ;
    setCeDatalist([]);
    setwholesalers([]);
    pharmacyData = [];
    ceData = [];
    cpData = [];
    tpaerror = "" ;
    cperror = "" ;
    setOptSelected({ optSelected: "-1" });
    setSelectedCP(null);
},[accountype]);

useEffect(()=>{
    setOptionSelected({ optionSelected: "-1" });
    purchaseOrder.searchTerms.ceIds = {};
    setCeDatalist([]);
    setwholesalers([]);
    pharmacyData = [];
    ceData = [];
    cpData = [];
    tpaerror = [];
    setOptSelected({ optSelected: "-1" });
},[])

  const setAccessType = (data) => {
    if (data) {
      if (data.data[0].accessType == 'TPA')
        setIsTPA(true)
    }
    else {
      setIsTPA(false)
    }

  }

  const fetchWholesalers = async (thirdPartyAdminID) => {
    try {
      const { data } = await API.get(`GWConfig/Wholesaler/wholesalersListtpa/${thirdPartyAdminID}`, {
        hasDefaultURL: true,
        hideLoader:true,
      });
      if (data) {
        setwholesalers(data);
      } else {
        setwholesalers([]);
      }
    } catch (error) { }
  };

  const findCP = async (value) => {
    setChainPharmacyList(value);
  };

  const fetchPharmacyNamesBasedOnCP = async (selectedCP) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/Pharmacy/PHList/${selectedCP.value}/${selectedCP.associateTypeID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchWholesalersBasedOnCP = async (selectedCP) => {
    try {
      const { data } = await API.get(`GWConfig/Pharmacy/CPWholesalerList/${selectedCP.value}`, {
        hasDefaultURL: true,
        hideLoader:true,
      });
      if (data) {
        setwholesalers(data);
      } else {
        setwholesalers([]);
      }
    } catch (error) { }
  };

  const handleCPChange = (selected, setFieldValue) => {
    setOptSelected({ optSelected: -1 });
    if (selected) {
      cperror = "";
      setFieldValue("chainParmacyID", selected);
      setSelectedCP(selected);
      fetchWholesalersBasedOnCP(selected)
      fetchPharmacyNamesBasedOnCP(selected);
      purchaseOrder.searchTerms.chainPharmacyID = selected.value;
      purchaseOrder.searchTerms.Non340BTenantID = selected.Non340BTenantID;
      purchaseOrder.searchTerms.associateTypeID = selected.associateTypeID ;

    } else {
       cperror = "Chain Pharmacy is required";
      setwholesalers([]);
      setFieldValue("chainParmacyID", "");
      setSelectedCP(null);
      pharmacyData = [];
      purchaseOrder.searchTerms.Non340BTenantID = null;
      purchaseOrder.searchTerms.chainPharmacyID = null;
      purchaseOrder.searchTerms.associateTypeID = [] ;

    }
    updateStates(purchaseOrder);
  };


  const fetchPOStatus = async () => {
    pharmacyData = [];
    try {
      const { data } = await API.get("GWConfig/ThirdPartyAdmin/GetPOStatus", {
        hasDefaultURL: true,
      });
      if (data) {
        setPOStatus(data);
      } else {
        setPOStatus([]);
      }
    } catch (error) { }
  };

  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    setOptionSelected({ optionSelected: "-1" });
    purchaseOrder.searchTerms.ceIds = {};
    setCeDatalist([]);
    pharmacyData = [];
    ceData = [];
    setOptSelected({ optSelected: "-1" });
    if (tpa) {
      tpaerror = "";
      const { thirdPartyAdminID } = tpa;
      setFieldValue("thirdPartyAdminID", value);
      purchaseOrder.coveredEntity = "";
      purchaseOrder.searchTerms.coveredEntityID = "";
      purchaseOrder.pharmacy = "";
      purchaseOrder.searchTerms.pharmacyID = "";
      purchaseOrder.thirdPartyAdmin = tpa;
      purchaseOrder.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
      fetchWholesalers(thirdPartyAdminID);
      fetchCoveredEntities(thirdPartyAdminID);
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    } else {
      // setFieldValue("thirdPartyAdminID", "");
      purchaseOrder.coveredEntity = "";
      setCeDatalist([]);
       tpaerror = "Third Party Administartor is required";
      purchaseOrder.searchTerms.coveredEntityID = "";
      purchaseOrder.pharmacy = "";
      purchaseOrder.searchTerms.pharmacyID = "";
      purchaseOrder.thirdPartyAdmin = {};
      purchaseOrder.searchTerms.thirdPartyAdminID = "";
      pharmacyData = [];
      ceData = [];
      setwholesalers([]);
    }
    updateStates(purchaseOrder);
  };

  // const handleCEChange = (setFieldValue,entity) => {
  //   if (entity) {
  //     purchaseOrder.coveredEntity = entity;
  //     purchaseOrder.searchTerms.coveredEntityID = entity.id;
  //     purchaseOrder.pharmacy = '';
  //     purchaseOrder.searchTerms.pharmacyID = '';
  //     setFieldValue('coveredEntityID',entity.id)
  //   } else {
  //     purchaseOrder.coveredEntity = null;
  //     purchaseOrder.searchTerms.coveredEntityID = '';
  //     purchaseOrder.pharmacy = '';
  //     purchaseOrder.searchTerms.pharmacyID = '';
  //     setFieldValue('coveredEntityID','')
  //   }
  //   updateStates(purchaseOrder);
  // };
  const fetchPharmacyNamesByTpaID = async (thirdPartyAdminID) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/GetPharmaciesByTpaId/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const fetchPharmacyNames = async (selected) => {
    let payloads = [];
    pharmacyData = [];
    for (var x in selected) {
      var rw = selected[x];
      payloads.push(rw.value);
    }
    let payload = {};
    payload.CoveredIDS = payloads;
    try {
      const { data } = await API.post(
       `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          ceData.push({ value: data[x].id, label: data[x].description });
        }
        setCeDatalist(ceData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchChainPharmacies = async () => {
    setCpDatalist([]);
    cpData = [];
    try {
      const { data } = await API.get(
        `GWConfig/pharmacy/CPlist`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          cpData.push({ value: data[x].chainPharmacyID, label: data[x].chainPharmacyName, Non340BTenantID: data[x].tenantID , associateTypeID : data[x].associateTypeID  });
        }
        setCpDatalist(cpData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };





  // const handlePHChange = (setFieldValue,pharmacy) => {
  //   if (pharmacy) {
  //     purchaseOrder.pharmacy = pharmacy;
  //     purchaseOrder.searchTerms.pharmacyID = pharmacy.id;
  //     setFieldValue('pharmacyID',pharmacy.id)
  //   } else {
  //     purchaseOrder.pharmacy = '';
  //     purchaseOrder.searchTerms.pharmacyID = '';
  //     setFieldValue('pharmacyID','')
  //   }
  //   updateStates(purchaseOrder);
  // };

  const handleStatusChange = ({ target: { value } }, setFieldValue) => {
    if (value) {
      const findObj = find(poStatus, {
        id: parseInt(value),
      });
      purchaseOrder.orderStatus = findObj;
      purchaseOrder.searchTerms.orderStatusID = findObj.id;
      setFieldValue("orderStatusID", value);
    } else {
      purchaseOrder.orderStatus = "";
      purchaseOrder.searchTerms.orderStatusID = "";
      setFieldValue("orderStatusID", "");
    }
    updateStates(purchaseOrder);
  };

  const handleWhChange = ({ target: { value } }, setFieldValue) => {
    if (value) {
      const findObj = find(wholesalers, {
        wholesalerID: parseInt(value),
      });
      purchaseOrder.wholesaler = findObj;
      purchaseOrder.searchTerms.wholesalerID = findObj.wholesalerID;
      setFieldValue("wholesalerID", value);
    } else {
      purchaseOrder.wholesaler = "";
      purchaseOrder.searchTerms.wholesalerID = "";
      setFieldValue("wholesalerID", "");
    }
    updateStates(purchaseOrder);
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    purchaseOrder.searchTerms.startDate = moment(new Date(startDate)).format(
      "MM/DD/YYYY"
    );
    updateStates(purchaseOrder);
  };

  const handleEndDate = (endDate) => {
    purchaseOrder.searchTerms.endDate = moment(new Date(endDate)).format(
      "MM/DD/YYYY"
    );
    updateStates(purchaseOrder);
  };

  const handleOnChange = ({ target: { value } }) => {
    purchaseOrder.searchTerms.invoicenumber = value;
    updateStates(purchaseOrder);
  };

  const handleOnChangePONumber = ({ target: { value } }) => {
    purchaseOrder.searchTerms.poNumber = value;
    updateStates(purchaseOrder);
  };

  const handleSubmit = async (val, actions) => {
    let coveredEntityIDS = [];
    for (var x in selectedOption.optionSelected) {
      var rw = selectedOption.optionSelected[x];
      coveredEntityIDS.push(rw.value);
    }
    let pharmacyIDs = [];
    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x];
      pharmacyIDs.push(rw.value);
    }

    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    if (selectedCP) values.chainpharmacyID = selectedCP.value;

    if (thirdPartyAdminID) values.thirdPartyAdminID;
    // if(coveredEntityID) values.coveredEntityID=coveredEntityID;
    // if (pharmacyID) values.pharmacyID = pharmacyID;
    if (pharmacyIDs > [0]) values.pharmacyIDs = pharmacyIDs;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;
    if (poNumber) values.poNumber = poNumber;
    if (invoicenumber) values.invoicenumber = invoicenumber;
    if(orderStatusID == '') values.orderStatusID = ''
    if (startDate) values.startDate = startDate;
    if (endDate) values.endDate = endDate;
    purchaseOrder.search.currentPage = 1;
    values.accountype = accountype;
    if (thirdPartyAdminID == "" && searchTerms.thirdPartyAdminID == '' && accountype == 1) {
      tpaerror = "Third Party Administrator is required";
    } 
    if (  purchaseOrder.searchTerms.chainPharmacyID == null && accountype == 2) {
      cperror = "Chain Pharmacy is required";
    }
      updateStates(purchaseOrder);
      await onSearch(values);
      setSubmitting(false);
    console.log(handleSubmit,"submit");
  };

  const handleCEChange = (selected) => {
    if (selected.length !== 0) {
      setOptSelected({
        optSelected: -1,
      });
    }
    if (selected.length === 0) {
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    }
    pharmacyData = [];
    setOptionSelected({
      optionSelected: selected,
    });
    purchaseOrder.searchTerms.ceIds = selected;
    updateStates(purchaseOrder);
    fetchPharmacyNames(selected);
  };


  const handlepharmacyChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    purchaseOrder.searchTerms.pharmacyids = selected;
    updateStates(purchaseOrder);
  };

  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    resetStates("purchaseOrder");
    setOptionSelected({ optionSelected: "-1" });
    purchaseOrder.searchTerms.ceIds = {};
    purchaseOrder.searchTerms.chainPharmacyID = null;
    purchaseOrder.searchTerms.poNumber = '' ;
    setCeDatalist([]);
    setwholesalers([]);
    pharmacyData = [];
    ceData = [];
    cpData = [];
    tpaerror = "" ;
    cperror = "" ;
    setOptSelected({ optSelected: "-1" });
    setSelectedCP(null);
  };


  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={searchTerms}
      validationSchema={accountype == 1 ? validationSchema : false}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting, handleSubmit, resetForm, setFieldValue } = props;
        return (
          <>
          <div  className="d-flex justify-content-between">
            <h5 className="f-16 text-primary font-weight-700">
            Search Purchase Orders
            </h5>
             {accountype == 1 &&
                        <Button color='primary' 
                        className="reset addbtn ms-3" size='sm' onClick={onToggleAddOrderModal} 
                        disabled={(ceIds.length != 1 || searchTerms.pharmacyids.length != 1) || (selectedOption.optionSelected == '-1' || selectedOpt.optSelected == '-1')}  hidden={!hasPermission('ADDPO')}
                        >
                          <span className="right_5">
                            {" "}
                            <img src={plus} alt="" />
                          </span>{" "}  Add
                        </Button>
            
                      }
                      </div>
            <Row>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="claimtype">Account Type</Label>
                  <Field
                    id="accountype"
                    name="accountype"
                    type="text"
                    value={accountype}
                    onChange={(e) => handelAccountype(e, setFieldValue)}
                    component={FormikSelectField}
                    options={accountypevalues}
                    show={false}
                    defaultoption='--select--'
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>
              </Col>
              {accountype == 1 &&
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="tpa">Third Party Administrator</Label>
                    <ThirdPartyAdmin
                      value={thirdPartyAdminID}
                      name="thirdPartyAdminID"
                      onChange={(value, tpa) =>
                        handleThirdPartyAdminChange(value, setFieldValue, tpa)
                      }
                    />
                    {(tpaerror.length > 0) ? (<div className="text-danger f-12">
                      {tpaerror}
                    </div>) : null}
                  </FormGroup>
                </Col>
              }
              {accountype == 2 &&
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="chainpharmacy">Chain Pharmacy</Label>

                    <ReactSelect
                      name="chainpharmacy"
                      id="chainpharmacy"
                      options={cpDatalist}
                      IndicatorSeparator
                      // isMult
                      placeholder="Select..."
                      defaultValue="select"
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      optionSelected={true}
                      inputValue={chainPharmacyList}
                      onInputChange={findCP}
                      components={{
                        Option,
                        IndicatorSeparator: () => null,
                        // ValueContainer: LimitedChipsContainer,
                      }}
                      isSearchable="true"
                      onChange={(value) => handleCPChange(value, setFieldValue)}
                      value={selectedCP}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className="claim_info required"
                      maxMenuHeight={220}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        option: (provided) => ({
                          ...provided,
                          display: 'flex',
                          alignItems: 'flex-start',
                        })
                      }}
                    />


                    {/* <Select
                      id="chainpharmacy"
                      className="form-field-large inner-shadow-field required" //npi-name
                      classNamePrefix="select"
                      IndicatorSeparator
                      isSearchable={true}
                      placeholder="Select..."
                      defaultValue="select"
                      isClearable={true}
                      name="chainpharmacy"
                      options={cpDatalist}
                      value={selectedCP}
                      inputValue={chainPharmacyList}
                      onInputChange={findCP}
                      onChange={(value) => handleCPChange(value, setFieldValue)}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      // isDisabled={!tenantID}
                      components={{
                        // DropdownIndicator: () => null,
                        Option,
                        IndicatorSeparator: () => null,
                      }}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                      }}
                    /> */}
                    {(cperror.length > 0) ? (<div className="text-danger f-12">
                      {cperror}
                    </div>) : null}
                  </FormGroup>
                </Col>}
              {accountype == 1 && <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="entity">Covered Entity</Label>
                  {/* <CoveredEntity
                  thirdPartyAdminID={thirdPartyAdminID}
                  onSelect={(value)=>handleCEChange(setFieldValue,value)}
                  selectedCE={coveredEntity}
                  /> */}
                  <ReactSelect
                    name="ceDatalist"
                    options={ceDatalist}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handleCEChange}
                    value={selectedOption.optionSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option : (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>}

              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="pharmacyname">Pharmacy</Label>
                  {/* <Pharmacy
                  thirdPartyAdminID={thirdPartyAdminID}
                  coveredEntityID={coveredEntityID}
                  onSelect={(value)=>handlePHChange(setFieldValue,value)}
                  selectedPH={pharmacy}
                  /> */}
                  <ReactSelect
                    name="pharmacyData"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlepharmacyChange}
                    value={selectedOpt.optSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option : (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="orderStatus">Order Status</Label>
                  <Field
                    id="orderStatusID"
                    name="orderStatusID"
                    type="text"
                    value={orderStatusID}
                    onChange={(e) => handleStatusChange(e, setFieldValue)}
                    component={FormikSelectField}
                    options={poStatus}
                    show={true}
                    defaultoption="--All--"
                    keys={{
                      id: "id",
                      label: "description",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="poNumber">Purchase Order Number</Label>
                  <Input
                    id="poNumber"
                    name="poNumber"
                    type="text"
                    placeholder="Enter PO Number"
                    autoComplete="off"
                    show={true}
                    value = {purchaseOrder.searchTerms.poNumber}
                    // component={FormikInputField}
                    // onKeyUp={handleOnChangePONumber}
                    onChange={handleOnChangePONumber}

                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="wholesaler">Wholesaler</Label>
                  <Field
                    id="wholesalerID"
                    name="wholesalerID"
                    type="text"
                    value={wholesalerID}
                    onChange={(e) => handleWhChange(e, setFieldValue)}
                    component={FormikSelectField}
                    options={wholesalers}
                    show={true}
                    defaultoption="--Select--"
                    keys={{
                      id: "wholesalerID",
                      label: "wholeSalerName",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={6}>
                <FormGroup>
                  <Label for="invoicenumber">Invoice Number</Label>
                  <Input
                    id="invoicenumber"
                    name="invoicenumber"
                    type="text"
                    autoComplete="off"
                    placeholder="Enter Invoice Number"
                    show={true}
                    // component={FormikInputField}
                    // onKeyUp={handleOnChange}
                    value={purchaseOrder.searchTerms.invoicenumber}
                    onChange={handleOnChange}
                  />
                </FormGroup>
              </Col>

              <Col md={3} sm={3} xs={3} className="pe-sm-4">
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>Start Date</Label>
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <Field
                          type="text"
                          id="startDate"
                          name="startDate"
                          autoComplete="off"
                          placeholder="Select a date"
                          value={startDate}
                          show={true}
                          component={FormikDatePicker}
                          onChange={handleStartDate}
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("startDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup>
                      <Label>End Date</Label>
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <Field
                          type="text"
                          id="endDate"
                          name="endDate"
                          autoComplete="off"
                          placeholder="Select a date"
                          value={endDate}
                          show={true}
                          component={FormikDatePicker}
                          onChange={handleEndDate}
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("endDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>{" "}

                </Row>
              </Col>
            </Row>

            <Row className="d-flex justify-content-end">
              <Col md="auto" className="">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="search"

                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button className="reset" color="primary" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>
            <Modal
        isOpen={addOrderModal}
        toggle={onToggleAddOrderModal}
        size='xl'
        className='addpo'
      >
        <ModalHeader toggle={onToggleAddOrderModal}>
          Add Order
        </ModalHeader>
        <ModalBody>
          <AddOrderModal isOpen={addOrderModal} toggle={onToggleAddOrderModal} tenantID={tenantID} ceid={searchTerms.ceIds} phid={searchTerms.pharmacyids} tpid={thirdPartyAdminID} 
          refetch={refetch} 
          />
        </ModalBody>
      </Modal> 
          </>
        
        );
      }}
      
    ></Formik>
  );
};

export default SearchOrders;
